import React, { useEffect, useState } from "react";
import { CheckBoxInput } from "../common/Buttons";
import { IconColumnSpacing } from "../Layout/Icons";
import styled from "styled-components";
import { useMemo } from "react";
import { ButtonRoundedSort, ButtonSettings } from "../buttons";
import ImumToAkeneoColumn from "./ImumToAkeneoColumn";
import ImumTdPreview from "./ImumTdPreview";
import useDebounce from "../../hooks/useDebounce";
import { FaCaretDown } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  imumDisableChannelPriceScope,
  imumDisableChannelPriceScopeParams,
} from "../../redux/Actions/imum_action";

const columnsWithPermissions = [
  "SKU",
  "Prod. cat.",
  "Brand",
  "MPN",
  "EAN",
  "Prime cost",
  "Failure",
  "Old price",
  "New price",
  "New margin",
  "New price competitor",
  "Min market price",
  "Min market markup",
  "Cheapest competitor",
  "Price change",
  "Store prices",
];

const ImumProductTable = ({
  countriesAreDisplayed,
  data,
  checked,
  setChecked,
  competitor,
  page,
  loading,
  lastBookElementRef,
  table_sort,
  setFilters,
  hasMore,
  imum_product_tags,
  filterString,
  imum_rules,
  failed,
  totalLength,
}) => {
  const [showColumns, setShowColumns] = useState(
    JSON.parse(localStorage.getItem("imum_columns")) || columnsWithPermissions
  );
  const [tableHeight, setTableHeight] = useState(0);
  const [active, setActive] = useState(false);
  const [columnWidthMain, setColumnWidthMain] = useState(
    JSON.parse(localStorage.getItem("imum_prod_title_column_width")) || 288
  );

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.key == "Escape") return setActive(false);
    });
  }, []);

  const available_stores = useMemo(() => {
    if (!data) return [];
    if (data?.length == 0) return [];

    const extra_columns = {
      LT: [],
      LV: [],
      EE: [],
      FI: [],
    };
    if (!data) return [];
    data.forEach((d) => {
      d.today_supplier_prices.forEach((tsp) => {
        if (countriesAreDisplayed && !countriesAreDisplayed.includes(tsp.category)) return false;
        if (!extra_columns[tsp.category]) return console.log(tsp.category);
        if (!extra_columns[tsp.category].includes(tsp.shop))
          extra_columns[tsp.category].push(tsp.shop);
      });
    });

    return Object.entries(extra_columns)
      .map((d) => {
        return d[1].map((s) => ({
          title: s,
          label: s,
          value: s,
          country: d[0],
        }));
      })
      .flat(1);
  }, [data.length]);

  useEffect(() => {
    const height = () => {
      let elementPosition = 0;
      if (document.querySelector("hr")?.getBoundingClientRect()?.top)
        elementPosition = document
          .querySelector(".table-responsive")
          ?.getBoundingClientRect()?.top;

      if (!hasMore && elementPosition)
        return window.innerHeight - elementPosition - 36;
      return window.innerHeight - elementPosition - 5;
    };
    setTableHeight(height());
    console.count("Height counting");
  }, [
    loading,
    hasMore,
    data.length,
    competitor.length,
    available_stores.length,
    countriesAreDisplayed.length,
  ]);

  const columns = useMemo(() => {
    const default_columns = [
      {
        title: "Prod. title",
      },
      {
        title: "SKU",
      },
      {
        title: "MPN",
      },
      {
        title: "EAN",
      },
      {
        title: "Prod. cat.",
      },
      {
        title: "Brand",
      },
      {
        title: "Prime cost",
      },
      {
        title: "Failure",
      },
      {
        title: "for_settings",
      },
      // {
      //   title: "Brand",
      //   lang: "lv",
      // },

      {
        title: "Old price",
        lang: "lv",
      },

      {
        title: "New price",
        lang: "lv",
      },

      {
        title: "New margin",
        lang: "lv",
      },

      {
        title: "New price competitor",
        lang: "lv",
      },
      {
        title: "Min market price",
        lang: "lv",
      },
      {
        title: "Min market markup",
        lang: "lv",
      },
      {
        title: "Cheapest competitor",
        lang: "lv",
      },
      {
        title: "Price change",
        lang: "lv",
      },
      {
        title: "",
      },
    ];

    if (!data) return [];
    if (data?.length == 0) return [];
    const stores = showColumns.includes("Store prices")
      ? available_stores
          .filter((d) => {
            if (competitor.length == 0) return true;
            if (competitor.includes(d.value)) return true;
            return false;
          })
          .map((d) => ({
            its_shop: true,
            title: d.label,
            country: d.country,
          }))
      : [];
    console.log({ failed });
    return [
      ...default_columns.filter((d) => {
        if (!failed && d.title == "Failure") return false;
        if (columnsWithPermissions.includes(d.title))
          return showColumns.includes(d.title);
        return true;
      }),
      ...stores,
    ];
  }, [competitor.length, showColumns.length, failed]);

  // console.log({ height: height() });
  const renderStyle = (lang, title) => {
    let basic_styled = {
      borderBottom: `1px solid #BFBFBF`,
      position: "sticky",
      top: 0,
      zIndex: 15,
    };
    if (lang) {
      basic_styled.borderLeft = "1px solid #BFBFBF";
      basic_styled.borderRight = "1px solid #BFBFBF";
    }
    if (title == "Prime cost with VAT") basic_styled.minWidth = 90;
    if (title == "Prod. title") basic_styled.zIndex = 20;
    if (title == "for_settings") basic_styled.zIndex = 20;
    if (title == "New price") basic_styled.zIndex = 16;

    return basic_styled;
  };

  const showColumnAvailable = (val) => showColumns.includes(val);
  // console.log({ columns, data });
  return (
    <div
      className="table-responsive"
      style={{
        height: tableHeight,
      }}
    >
      <TableLayout className="table table-hover mt-3 " sticky={true}>
        <thead>
          <tr className="text-muted">
            {columns.map((d, idx) => (
              <React.Fragment key={`${d.title}_${d.lang ?? d.country}`}>
                {d.title == "for_settings" ? (
                  <th
                    className={
                      idx == 0
                        ? "bg-white align-middle text-black"
                        : `bg-white align-middle text-black ${
                            d.lang ? "px-0" : ""
                          }`
                    }
                    style={renderStyle(d.lang, d.title)}
                    colSpan={d.lang ? countriesAreDisplayed.length : 1}
                  >
                    <div>
                      <ButtonSettings
                        columns_type="imum_columns"
                        columns={columnsWithPermissions}
                        showColumns={showColumns}
                        setShowColumns={setShowColumns}
                      />
                    </div>
                  </th>
                ) : d.title == "Prod. title" ? (
                  <ColumnProdTitle
                    loading={loading}
                    checked={checked}
                    d={d}
                    data={data}
                    page={page}
                    setChecked={setChecked}
                    columnWidthMain={columnWidthMain}
                    setColumnWidthMain={setColumnWidthMain}
                    table_sort={table_sort}
                    setFilters={setFilters}
                    filterString={filterString}
                    totalLength={totalLength}
                    countriesAreDisplayed={countriesAreDisplayed}
                  />
                ) : d.lang ? (
                  <th
                    className={
                      idx == 0
                        ? "bg-white align-middle text-black"
                        : `bg-white align-middle text-black ${
                            d.lang ? "px-0" : ""
                          }`
                    }
                    style={renderStyle(d.lang, d.title)}
                    colSpan={d.lang ? countriesAreDisplayed.length : 1}
                  >
                    <div className="">
                      {d.lang && (
                        <div
                          className={`font-semi-bold text-sm mb-2 text-center`}
                        >
                          {d.title}
                        </div>
                      )}
                      <ImumTdPreview
                        item={d}
                        shorting={
                          [
                            "Price change",
                            "New margin",
                            "New price competitor",
                            "Min market price",
                            "Min market markup",
                            "Cheapest competitor",
                          ].includes(d.title)
                            ? true
                            : false
                        }
                        values={{
                          countries: countriesAreDisplayed,
                        }}
                        table_sort={table_sort}
                        setFilters={setFilters}
                        filter_recognition={{
                          filterString,
                          checked,
                        }}
                      />
                    </div>
                  </th>
                ) : !(d.its_shop && d.country && countriesAreDisplayed && !countriesAreDisplayed.includes(d.country)) ? (
                  <th
                    className={
                      idx == 0
                        ? "bg-white align-middle text-black"
                        : `bg-white align-middle text-black ${
                            d.lang ? "px-0" : ""
                          }`
                    }
                    style={renderStyle(d.lang, d.title)}
                    colSpan={d.lang ? countriesAreDisplayed.length : 1}
                  >
                    <div>
                      {d.country && `[${d.country}]`} {d.title}
                    </div>
                  </th>
                ) : null
                }
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((d, idx) => {
            const checked_boolean = checked.includes(d.id);
            return (
              <ImumToAkeneoColumn
                key={`${d.id}_{${idx}`}
                {...d}
                columns={columns}
                lastBookElementRef={
                  data.length === idx + 1 ? lastBookElementRef : null
                }
                showColumnAvailable={showColumnAvailable}
                setChecked={() => {
                  setChecked((prev) => {
                    if (checked_boolean)
                      return prev.filter((pr) => pr !== d.id);
                    return [...new Set([...prev, d.id])];
                  });
                }}
                checked={checked_boolean}
                countriesAreDisplayed={countriesAreDisplayed}
                active={active}
                setActive={setActive}
                imum_product_tags={imum_product_tags}
                columnWidthMain={columnWidthMain}
                imum_rules={imum_rules}
                failed={failed}
              />
            );
          })}
        </tbody>
      </TableLayout>
    </div>
  );
};

export default ImumProductTable;

const ColumnProdTitle = ({
  loading,
  checked,
  d,
  data,
  page,
  setChecked,
  columnWidthMain,
  setColumnWidthMain,
  table_sort,
  setFilters,
  filterString,
  countriesAreDisplayed,
}) => {
  const [columnWidth, setColumnWidth] = useState(columnWidthMain);
  const [isDragging, setIsDragging] = useState(false);
  const { totals } = useSelector((state) => state.custom);
  const customs = useSelector((state) => state.custom);
  useDebounce(
    () => {
      setColumnWidthMain(columnWidth);
      localStorage.setItem("imum_prod_title_column_width", columnWidth);
    },
    600,
    [columnWidth]
  );

  const all_checked = useMemo(() => {
    if (loading) return false;
    if (checked.length == 0) return false;
    if (data.every((d) => checked.includes(d.id))) return true;
    return false;
  }, [loading, checked?.length, data?.length, page]);

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newWidth = columnWidth + e.movementX;
    if (288 >= newWidth) return;
    setColumnWidth(newWidth);
  };

  console.log("checked", checked);

  return (
    <th
      className={"bg-white align-middle text-black p-left"}
      style={{
        borderBottom: `1px solid #BFBFBF`,
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
      colSpan={1}
      onMouseDown={() => setIsDragging(true)}
      onMouseUp={() => setIsDragging(false)}
      onMouseLeave={() => setIsDragging(false)}
      onMouseMove={handleMouseMove}
    >
      <div
        className="d-flex align-items-center justify-content-between"
        style={{
          width: `${columnWidth}px`,
          cursor: "grab",
        }}
      >
        <CheckBoxInput
          text={`(${checked.length}) ${d.title}`}
          checked={all_checked}
          onChange={() => {
            setChecked((prev) => {
              let obj = [...prev];
              const all_data = [];
              data.forEach((d) => all_data.push(d.id));
              if (all_checked) {
                return prev.filter((d) => !all_data.includes(d));
              }
              return [...new Set([...obj, ...all_data])];
            });
          }}
        />
        <div>
          <ButtonRoundedSort
            active={
              (table_sort?.type == "product_name" && table_sort?.sort) || ""
            }
            setActive={(sort) => {
              setFilters({
                name: "table_sort",
                value: {
                  ...table_sort,
                  lang: " ",
                  sort,
                  type: sort == "" ? "" : "product_name",
                },
              });
            }}
          />
        </div>
        <div className="flex-1 d-flex align-items-center justify-content-end">
          <IconColumnSpacing
            className="m-1 mr-2"
            style={{
              width: 15,
              height: 15,
            }}
          />
        </div>
      </div>
    </th>
  );
};

const TableLayout = styled.table`
  ${(props) =>
    props.sticky &&
    `
tr > th:first-child,
tr > td:first-child {
  position: sticky !important;
  left: 0;
  background-color: #fff;
  z-index: 19;
}
tr:nth-child(odd) > td:first-child {
    background-color: #fff;
  }
  tr:nth-child(even) > td:first-child {
    background-color: #f9f9f9;
  }
  `}
`;
